import * as Types from '@x/schemas/content';

import { gql } from 'apollo-angular';
import { DisplayControlAttributesFragmentDoc, VideoConfigAttributesFragmentDoc } from './common.gql.generated';
import { UploadFileResponseFragmentDoc } from './media.gql.generated';
export type ComponentThemeLayoutAttributesFragment = { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined };

export type ComponentBrochureActionBannerAttributesFragment = { __typename: 'ComponentBrochureActionBanner', title?: string | null | undefined, description?: string | null | undefined, actionBannerItems: Array<{ __typename: 'ComponentBrochureActionBannerItem', text?: string | null | undefined, url?: string | null | undefined, openInNewTab: boolean, media?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined>, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined }, displayControl?: { __typename: 'ComponentCommonDisplayControl', showOnDevices?: any | null | undefined } | null | undefined };

export type ComponentBrochureNavigationItemAttributesFragment = { __typename: 'ComponentBrochureNavigationItem', text: string, url: string, openInNewTab: boolean };

export type ComponentBrochureActionBannerItemAttributesFragment = { __typename: 'ComponentBrochureActionBannerItem', text?: string | null | undefined, url?: string | null | undefined, openInNewTab: boolean, media?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type ComponentBrochureActionGridAttributesFragment = { __typename: 'ComponentBrochureActionGrid', title?: string | null | undefined, description?: string | null | undefined, actionGridItems: Array<{ __typename: 'ComponentBrochureActionGridItem', title?: string | null | undefined, text?: string | null | undefined, url?: string | null | undefined, openInNewTab: boolean, emphasize: boolean, media: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } } | null | undefined>, background?: { __typename: 'ComponentThemeBackground', color: Types.BackgroundColor } | null | undefined, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined }, displayControl?: { __typename: 'ComponentCommonDisplayControl', showOnDevices?: any | null | undefined } | null | undefined };

export type ComponentBrochureActionGridItemAttributesFragment = { __typename: 'ComponentBrochureActionGridItem', title?: string | null | undefined, text?: string | null | undefined, url?: string | null | undefined, openInNewTab: boolean, emphasize: boolean, media: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } };

export type ComponentBrochureActionListAttributesFragment = { __typename: 'ComponentBrochureActionList', title?: string | null | undefined, description?: string | null | undefined, actionListItems: Array<{ __typename: 'ComponentBrochureActionListItem', text?: string | null | undefined, description?: string | null | undefined, url?: string | null | undefined, openInNewTab: boolean, media?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined>, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined }, displayControl?: { __typename: 'ComponentCommonDisplayControl', showOnDevices?: any | null | undefined } | null | undefined };

export type ComponentBrochureActionListItemAttributesFragment = { __typename: 'ComponentBrochureActionListItem', text?: string | null | undefined, description?: string | null | undefined, url?: string | null | undefined, openInNewTab: boolean, media?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type ComponentBrochureBannerAttributesFragment = { __typename: 'ComponentBrochureBanner', title?: string | null | undefined, useSecondaryMediaForMobile?: boolean | null | undefined, description?: string | null | undefined, whiteText?: boolean | null | undefined, bannerHeight: Types.Enum_Componentbrochurebanner_Bannerheight, bannerType?: Types.Enum_Componentbrochurebanner_Bannertype | null | undefined, media: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined }, videoConfig?: { __typename: 'ComponentCommonVideoConfig', mode?: Types.Enum_Componentcommonvideoconfig_Mode | null | undefined } | null | undefined, secondaryMedia?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined, buttons?: Array<{ __typename: 'ComponentBrochureButton', text: string, url: string, color: Types.BrochureButtonColor, alignment: Types.BrochureButtonAlignment, appearance: Types.BrochureButtonAppearance, openInNewTab: boolean } | null | undefined> | null | undefined, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined }, displayControl?: { __typename: 'ComponentCommonDisplayControl', showOnDevices?: any | null | undefined } | null | undefined };

export type ComponentBrochureButtonAttributesFragment = { __typename: 'ComponentBrochureButton', text: string, url: string, color: Types.BrochureButtonColor, alignment: Types.BrochureButtonAlignment, appearance: Types.BrochureButtonAppearance, openInNewTab: boolean };

export type ComponentBrochureSpacerAttributesFragment = { __typename: 'ComponentBrochureSpacer', verticalSpace: Types.BrochureVerticalSpace, background?: { __typename: 'ComponentThemeBackground', color: Types.BackgroundColor } | null | undefined };

export type ComponentBrochureCardGridAttributesFragment = { __typename: 'ComponentBrochureCardGrid', title?: string | null | undefined, description?: string | null | undefined, cardGridType?: Types.Enum_Componentbrochurecardgrid_Cardgridtype | null | undefined, background?: { __typename: 'ComponentThemeBackground', color: Types.BackgroundColor } | null | undefined, cardItems: Array<{ __typename: 'ComponentBrochureCardGridItem', description?: string | null | undefined, url?: string | null | undefined, image?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined>, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined }, displayControl?: { __typename: 'ComponentCommonDisplayControl', showOnDevices?: any | null | undefined } | null | undefined };

export type ComponentBrochureCardGridItemAttributesFragment = { __typename: 'ComponentBrochureCardGridItem', description?: string | null | undefined, url?: string | null | undefined, image?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type ComponentBrochureCarouselAttributesFragment = { __typename: 'ComponentBrochureCarousel', title?: string | null | undefined, description?: string | null | undefined, carouselType: Types.BrochureCarouselType, carouselLayout?: Types.BrochureCarouselLayout | null | undefined, carouselItems: Array<{ __typename: 'ComponentBrochureCarouselItem', title?: string | null | undefined, description?: string | null | undefined, url?: string | null | undefined, media: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } } | null | undefined>, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined }, displayControl?: { __typename: 'ComponentCommonDisplayControl', showOnDevices?: any | null | undefined } | null | undefined };

export type ComponentBrochureCarouselItemAttributesFragment = { __typename: 'ComponentBrochureCarouselItem', title?: string | null | undefined, description?: string | null | undefined, url?: string | null | undefined, media: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } };

export type ComponentBrochureFaqAttributesFragment = { __typename: 'ComponentBrochureFaq', title?: string | null | undefined, description?: string | null | undefined, faqItems: Array<{ __typename: 'ComponentBrochureFaqItem', question: string, answer: string } | null | undefined>, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined } };

export type ComponentBrochureFaqItemAttributesFragment = { __typename: 'ComponentBrochureFaqItem', question: string, answer: string };

export type ComponentBrochureSectionOneAttributesFragment = { __typename: 'ComponentBrochureSectionOne', title?: string | null | undefined, description?: string | null | undefined, background?: { __typename: 'ComponentThemeBackground', color: Types.BackgroundColor } | null | undefined, buttons?: Array<{ __typename: 'ComponentBrochureButton', text: string, url: string, color: Types.BrochureButtonColor, alignment: Types.BrochureButtonAlignment, appearance: Types.BrochureButtonAppearance, openInNewTab: boolean } | null | undefined> | null | undefined, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined }, displayControl?: { __typename: 'ComponentCommonDisplayControl', showOnDevices?: any | null | undefined } | null | undefined };

export type ComponentBrochureSectionThreeAttributesFragment = { __typename: 'ComponentBrochureSectionThree', title?: string | null | undefined, descriptionOne?: string | null | undefined, descriptionTwo?: string | null | undefined, descriptionThree?: string | null | undefined, background?: { __typename: 'ComponentThemeBackground', color: Types.BackgroundColor } | null | undefined, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined }, buttonOne?: Array<{ __typename: 'ComponentBrochureButton', text: string, url: string, color: Types.BrochureButtonColor, alignment: Types.BrochureButtonAlignment, appearance: Types.BrochureButtonAppearance, openInNewTab: boolean } | null | undefined> | null | undefined, buttonTwo?: Array<{ __typename: 'ComponentBrochureButton', text: string, url: string, color: Types.BrochureButtonColor, alignment: Types.BrochureButtonAlignment, appearance: Types.BrochureButtonAppearance, openInNewTab: boolean } | null | undefined> | null | undefined, buttonThree?: Array<{ __typename: 'ComponentBrochureButton', text: string, url: string, color: Types.BrochureButtonColor, alignment: Types.BrochureButtonAlignment, appearance: Types.BrochureButtonAppearance, openInNewTab: boolean } | null | undefined> | null | undefined, displayControl?: { __typename: 'ComponentCommonDisplayControl', showOnDevices?: any | null | undefined } | null | undefined };

export type ComponentBrochureSectionTwoAttributesFragment = { __typename: 'ComponentBrochureSectionTwo', title?: string | null | undefined, descriptionOne?: string | null | undefined, descriptionTwo?: string | null | undefined, background?: { __typename: 'ComponentThemeBackground', color: Types.BackgroundColor } | null | undefined, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined }, buttonOne?: Array<{ __typename: 'ComponentBrochureButton', text: string, url: string, color: Types.BrochureButtonColor, alignment: Types.BrochureButtonAlignment, appearance: Types.BrochureButtonAppearance, openInNewTab: boolean } | null | undefined> | null | undefined, buttonTwo?: Array<{ __typename: 'ComponentBrochureButton', text: string, url: string, color: Types.BrochureButtonColor, alignment: Types.BrochureButtonAlignment, appearance: Types.BrochureButtonAppearance, openInNewTab: boolean } | null | undefined> | null | undefined, displayControl?: { __typename: 'ComponentCommonDisplayControl', showOnDevices?: any | null | undefined } | null | undefined };

export type ComponentBrochureSectionWithImageAttributesFragment = { __typename: 'ComponentBrochureSectionWithImage', title?: string | null | undefined, description?: string | null | undefined, sectionWithImageLayout: Types.BrochureSectionTextPosition, useSecondaryMediaForMobile?: boolean | null | undefined, sectionWithImageType?: Types.BrochureSectionWithImageLayout | null | undefined, isNarrow: boolean, height: Types.Enum_Componentbrochuresectionwithimage_Height, media: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined }, videoConfig?: { __typename: 'ComponentCommonVideoConfig', mode?: Types.Enum_Componentcommonvideoconfig_Mode | null | undefined } | null | undefined, secondaryMedia?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined, buttons?: Array<{ __typename: 'ComponentBrochureButton', text: string, url: string, color: Types.BrochureButtonColor, alignment: Types.BrochureButtonAlignment, appearance: Types.BrochureButtonAppearance, openInNewTab: boolean } | null | undefined> | null | undefined, background?: { __typename: 'ComponentThemeBackground', color: Types.BackgroundColor } | null | undefined, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined }, displayControl?: { __typename: 'ComponentCommonDisplayControl', showOnDevices?: any | null | undefined } | null | undefined };

export type ComponentBrochureEventListingAttributesFragment = { __typename: 'ComponentBrochureEventListing', title?: string | null | undefined, description?: string | null | undefined, background?: { __typename: 'ComponentThemeBackground', color: Types.BackgroundColor } | null | undefined, collectionFilter: { __typename: 'ComponentCommonCollectionFilter', sortColumn: string, sortOrder: Types.CollectionSortOrder, pageSize: number, filter?: any | null | undefined }, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined } };

export type ComponentBrochureBlogListingAttributesFragment = { __typename: 'ComponentBrochureBlogListing', title?: string | null | undefined, description?: string | null | undefined, background?: { __typename: 'ComponentThemeBackground', color: Types.BackgroundColor } | null | undefined, collectionFilter: { __typename: 'ComponentCommonCollectionFilter', sortColumn: string, sortOrder: Types.CollectionSortOrder, pageSize: number, filter?: any | null | undefined }, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined } };

export type ComponentShopProductListingAttributesFragment = { __typename: 'ComponentShopProductListing', title?: string | null | undefined, description?: string | null | undefined, productListingType: Types.Enum_Componentshopproductlisting_Productlistingtype, productCollectionFilter: { __typename: 'ComponentShopProductCollectionFilter', sortOrder: Types.ProductCollectionSortOrder, sortColumn?: Types.Enum_Componentshopproductcollectionfilter_Sortcolumn | null | undefined, productCount: number, taxonId?: number | null | undefined }, products?: Array<{ __typename: 'ComponentShopProduct', productId: number } | null | undefined> | null | undefined, layout: { __typename: 'ComponentThemeLayout', container?: Types.LayoutContainer | null | undefined, textPositionHorizontal?: Types.LayoutTextPosition | null | undefined, textPositionVertical?: Types.Enum_Componentthemelayout_Textpositionvertical | null | undefined, textAlignment?: Types.LayoutTextAlignment | null | undefined }, background?: { __typename: 'ComponentThemeBackground', color: Types.BackgroundColor } | null | undefined, displayControl?: { __typename: 'ComponentCommonDisplayControl', showOnDevices?: any | null | undefined } | null | undefined };

export type ComponentShopNavigationItemAttributesFragment = { __typename: 'ComponentShopNavigationItem', text: string, url: string, openInNewTab?: boolean | null | undefined, position?: number | null | undefined, taxonId?: number | null | undefined, icon?: string | null | undefined, media?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type ComponentShopChannelNotificationAttributesFragment = { __typename: 'ComponentShopChannelNotification', notificationText: string, background?: { __typename: 'ComponentThemeBackground', color: Types.BackgroundColor } | null | undefined };

export type ComponentCommonLivestreamAttributesFragment = { __typename: 'ComponentCommonLivestreamControl', floatingPlayer: boolean, playlist: string, channel: string };

export type ComponentBrochureHtmlContainerAttributesFragment = { __typename: 'ComponentBrochureHtmlContainer', content?: string | null | undefined };

export type ComponentShopFooterLinksAttributesFragment = { __typename: 'ComponentShopFooterLinkComponent', labelOne?: string | null | undefined, labelTwo?: string | null | undefined, labelThree?: string | null | undefined, labelFour?: string | null | undefined, linkCategoryOne?: Array<{ __typename: 'ComponentShopNavigationItem', text: string, url: string, openInNewTab?: boolean | null | undefined, position?: number | null | undefined, taxonId?: number | null | undefined, icon?: string | null | undefined, media?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, linkCategoryTwo?: Array<{ __typename: 'ComponentShopNavigationItem', text: string, url: string, openInNewTab?: boolean | null | undefined, position?: number | null | undefined, taxonId?: number | null | undefined, icon?: string | null | undefined, media?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, linkCategoryThree?: Array<{ __typename: 'ComponentShopNavigationItem', text: string, url: string, openInNewTab?: boolean | null | undefined, position?: number | null | undefined, taxonId?: number | null | undefined, icon?: string | null | undefined, media?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, linkCategoryFour?: Array<{ __typename: 'ComponentShopNavigationItem', text: string, url: string, openInNewTab?: boolean | null | undefined, position?: number | null | undefined, taxonId?: number | null | undefined, icon?: string | null | undefined, media?: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type ComponentBrochureAnchorAttributesFragment = { __typename: 'ComponentBrochureAnchor', anchorId: string };

export type ComponentBrochureExpansionPanelAttributesFragment = { __typename: 'ComponentBrochureExpansionPanel', title?: string | null | undefined, text?: string | null | undefined };

export type ComponentBrochureAccordionAttributesFragment = { __typename: 'ComponentBrochureAccordion', title?: string | null | undefined, description?: string | null | undefined, expansionPanel?: Array<{ __typename: 'ComponentBrochureExpansionPanel', title?: string | null | undefined, text?: string | null | undefined } | null | undefined> | null | undefined };

export type ComponentShopCatalogReelAttributesFragment = { __typename: 'ComponentShopCatalogReel', onlyShow4Products?: boolean | null | undefined, media: { __typename: 'UploadFileEntityResponse', data?: { __typename: 'UploadFileEntity', id?: string | null | undefined, attributes?: { __typename: 'UploadFile', name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, createdAt?: any | null | undefined, updatedAt?: any | null | undefined } | null | undefined } | null | undefined }, videoConfig?: { __typename: 'ComponentCommonVideoConfig', mode?: Types.Enum_Componentcommonvideoconfig_Mode | null | undefined } | null | undefined, productCollectionFilter: { __typename: 'ComponentShopProductCollectionFilter', sortOrder: Types.ProductCollectionSortOrder, sortColumn?: Types.Enum_Componentshopproductcollectionfilter_Sortcolumn | null | undefined, productCount: number, taxonId?: number | null | undefined }, products?: Array<{ __typename: 'ComponentShopProduct', productId: number } | null | undefined> | null | undefined, background?: { __typename: 'ComponentThemeBackground', color: Types.BackgroundColor } | null | undefined, displayControl?: { __typename: 'ComponentCommonDisplayControl', showOnDevices?: any | null | undefined } | null | undefined };

export const ComponentBrochureActionBannerItemAttributesFragmentDoc = gql`
    fragment ComponentBrochureActionBannerItemAttributes on ComponentBrochureActionBannerItem {
  text
  url
  openInNewTab
  media {
    ...UploadFileResponse
  }
}
    ${UploadFileResponseFragmentDoc}`;
export const ComponentThemeLayoutAttributesFragmentDoc = gql`
    fragment ComponentThemeLayoutAttributes on ComponentThemeLayout {
  container
  textPositionHorizontal
  textPositionVertical
  textAlignment
}
    `;
export const ComponentBrochureActionBannerAttributesFragmentDoc = gql`
    fragment ComponentBrochureActionBannerAttributes on ComponentBrochureActionBanner {
  title
  description
  actionBannerItems {
    ...ComponentBrochureActionBannerItemAttributes
  }
  layout {
    ...ComponentThemeLayoutAttributes
  }
  displayControl {
    ...DisplayControlAttributes
  }
}
    ${ComponentBrochureActionBannerItemAttributesFragmentDoc}
${ComponentThemeLayoutAttributesFragmentDoc}
${DisplayControlAttributesFragmentDoc}`;
export const ComponentBrochureNavigationItemAttributesFragmentDoc = gql`
    fragment ComponentBrochureNavigationItemAttributes on ComponentBrochureNavigationItem {
  text
  url
  openInNewTab
}
    `;
export const ComponentBrochureActionGridItemAttributesFragmentDoc = gql`
    fragment ComponentBrochureActionGridItemAttributes on ComponentBrochureActionGridItem {
  title
  text
  url
  openInNewTab
  media {
    ...UploadFileResponse
  }
  emphasize
}
    ${UploadFileResponseFragmentDoc}`;
export const ComponentBrochureActionGridAttributesFragmentDoc = gql`
    fragment ComponentBrochureActionGridAttributes on ComponentBrochureActionGrid {
  title
  description
  actionGridItems {
    ...ComponentBrochureActionGridItemAttributes
  }
  background {
    color
  }
  layout {
    ...ComponentThemeLayoutAttributes
  }
  displayControl {
    ...DisplayControlAttributes
  }
}
    ${ComponentBrochureActionGridItemAttributesFragmentDoc}
${ComponentThemeLayoutAttributesFragmentDoc}
${DisplayControlAttributesFragmentDoc}`;
export const ComponentBrochureActionListItemAttributesFragmentDoc = gql`
    fragment ComponentBrochureActionListItemAttributes on ComponentBrochureActionListItem {
  text
  description
  media {
    ...UploadFileResponse
  }
  url
  openInNewTab
}
    ${UploadFileResponseFragmentDoc}`;
export const ComponentBrochureActionListAttributesFragmentDoc = gql`
    fragment ComponentBrochureActionListAttributes on ComponentBrochureActionList {
  title
  description
  actionListItems(pagination: {limit: -1}) {
    ...ComponentBrochureActionListItemAttributes
  }
  layout {
    ...ComponentThemeLayoutAttributes
  }
  displayControl {
    ...DisplayControlAttributes
  }
}
    ${ComponentBrochureActionListItemAttributesFragmentDoc}
${ComponentThemeLayoutAttributesFragmentDoc}
${DisplayControlAttributesFragmentDoc}`;
export const ComponentBrochureButtonAttributesFragmentDoc = gql`
    fragment ComponentBrochureButtonAttributes on ComponentBrochureButton {
  text
  url
  color
  alignment
  appearance
  openInNewTab
}
    `;
export const ComponentBrochureBannerAttributesFragmentDoc = gql`
    fragment ComponentBrochureBannerAttributes on ComponentBrochureBanner {
  title
  media {
    ...UploadFileResponse
  }
  videoConfig {
    ...VideoConfigAttributes
  }
  secondaryMedia {
    ...UploadFileResponse
  }
  useSecondaryMediaForMobile
  description
  whiteText
  buttons {
    ...ComponentBrochureButtonAttributes
  }
  bannerHeight
  bannerType
  layout {
    ...ComponentThemeLayoutAttributes
  }
  displayControl {
    ...DisplayControlAttributes
  }
}
    ${UploadFileResponseFragmentDoc}
${VideoConfigAttributesFragmentDoc}
${ComponentBrochureButtonAttributesFragmentDoc}
${ComponentThemeLayoutAttributesFragmentDoc}
${DisplayControlAttributesFragmentDoc}`;
export const ComponentBrochureSpacerAttributesFragmentDoc = gql`
    fragment ComponentBrochureSpacerAttributes on ComponentBrochureSpacer {
  verticalSpace
  background {
    color
  }
}
    `;
export const ComponentBrochureCardGridItemAttributesFragmentDoc = gql`
    fragment ComponentBrochureCardGridItemAttributes on ComponentBrochureCardGridItem {
  description
  url
  image {
    ...UploadFileResponse
  }
}
    ${UploadFileResponseFragmentDoc}`;
export const ComponentBrochureCardGridAttributesFragmentDoc = gql`
    fragment ComponentBrochureCardGridAttributes on ComponentBrochureCardGrid {
  title
  description
  background {
    color
  }
  cardItems(pagination: {limit: -1}) {
    ...ComponentBrochureCardGridItemAttributes
  }
  layout {
    ...ComponentThemeLayoutAttributes
  }
  displayControl {
    ...DisplayControlAttributes
  }
  cardGridType
}
    ${ComponentBrochureCardGridItemAttributesFragmentDoc}
${ComponentThemeLayoutAttributesFragmentDoc}
${DisplayControlAttributesFragmentDoc}`;
export const ComponentBrochureCarouselItemAttributesFragmentDoc = gql`
    fragment ComponentBrochureCarouselItemAttributes on ComponentBrochureCarouselItem {
  title
  description
  media {
    ...UploadFileResponse
  }
  url
}
    ${UploadFileResponseFragmentDoc}`;
export const ComponentBrochureCarouselAttributesFragmentDoc = gql`
    fragment ComponentBrochureCarouselAttributes on ComponentBrochureCarousel {
  title
  description
  carouselItems(pagination: {limit: -1}) {
    ...ComponentBrochureCarouselItemAttributes
  }
  carouselType
  carouselLayout
  layout {
    ...ComponentThemeLayoutAttributes
  }
  displayControl {
    ...DisplayControlAttributes
  }
}
    ${ComponentBrochureCarouselItemAttributesFragmentDoc}
${ComponentThemeLayoutAttributesFragmentDoc}
${DisplayControlAttributesFragmentDoc}`;
export const ComponentBrochureFaqItemAttributesFragmentDoc = gql`
    fragment ComponentBrochureFaqItemAttributes on ComponentBrochureFaqItem {
  question
  answer
}
    `;
export const ComponentBrochureFaqAttributesFragmentDoc = gql`
    fragment ComponentBrochureFaqAttributes on ComponentBrochureFaq {
  title
  description
  faqItems {
    ...ComponentBrochureFaqItemAttributes
  }
  layout {
    ...ComponentThemeLayoutAttributes
  }
}
    ${ComponentBrochureFaqItemAttributesFragmentDoc}
${ComponentThemeLayoutAttributesFragmentDoc}`;
export const ComponentBrochureSectionOneAttributesFragmentDoc = gql`
    fragment ComponentBrochureSectionOneAttributes on ComponentBrochureSectionOne {
  title
  description
  background {
    color
  }
  buttons {
    ...ComponentBrochureButtonAttributes
  }
  layout {
    ...ComponentThemeLayoutAttributes
  }
  displayControl {
    ...DisplayControlAttributes
  }
}
    ${ComponentBrochureButtonAttributesFragmentDoc}
${ComponentThemeLayoutAttributesFragmentDoc}
${DisplayControlAttributesFragmentDoc}`;
export const ComponentBrochureSectionThreeAttributesFragmentDoc = gql`
    fragment ComponentBrochureSectionThreeAttributes on ComponentBrochureSectionThree {
  title
  descriptionOne
  descriptionTwo
  descriptionThree
  background {
    color
  }
  layout {
    ...ComponentThemeLayoutAttributes
  }
  buttonOne {
    ...ComponentBrochureButtonAttributes
  }
  buttonTwo {
    ...ComponentBrochureButtonAttributes
  }
  buttonThree {
    ...ComponentBrochureButtonAttributes
  }
  displayControl {
    ...DisplayControlAttributes
  }
}
    ${ComponentThemeLayoutAttributesFragmentDoc}
${ComponentBrochureButtonAttributesFragmentDoc}
${DisplayControlAttributesFragmentDoc}`;
export const ComponentBrochureSectionTwoAttributesFragmentDoc = gql`
    fragment ComponentBrochureSectionTwoAttributes on ComponentBrochureSectionTwo {
  title
  descriptionOne
  descriptionTwo
  background {
    color
  }
  layout {
    ...ComponentThemeLayoutAttributes
  }
  buttonOne {
    ...ComponentBrochureButtonAttributes
  }
  buttonTwo {
    ...ComponentBrochureButtonAttributes
  }
  displayControl {
    ...DisplayControlAttributes
  }
}
    ${ComponentThemeLayoutAttributesFragmentDoc}
${ComponentBrochureButtonAttributesFragmentDoc}
${DisplayControlAttributesFragmentDoc}`;
export const ComponentBrochureSectionWithImageAttributesFragmentDoc = gql`
    fragment ComponentBrochureSectionWithImageAttributes on ComponentBrochureSectionWithImage {
  title
  description
  sectionWithImageLayout
  media {
    ...UploadFileResponse
  }
  videoConfig {
    ...VideoConfigAttributes
  }
  secondaryMedia {
    ...UploadFileResponse
  }
  useSecondaryMediaForMobile
  buttons {
    ...ComponentBrochureButtonAttributes
  }
  background {
    color
  }
  layout {
    ...ComponentThemeLayoutAttributes
  }
  sectionWithImageType
  isNarrow
  height
  displayControl {
    ...DisplayControlAttributes
  }
}
    ${UploadFileResponseFragmentDoc}
${VideoConfigAttributesFragmentDoc}
${ComponentBrochureButtonAttributesFragmentDoc}
${ComponentThemeLayoutAttributesFragmentDoc}
${DisplayControlAttributesFragmentDoc}`;
export const ComponentBrochureEventListingAttributesFragmentDoc = gql`
    fragment ComponentBrochureEventListingAttributes on ComponentBrochureEventListing {
  title
  description
  background {
    color
  }
  collectionFilter {
    sortColumn
    sortOrder
    pageSize
    filter
  }
  layout {
    ...ComponentThemeLayoutAttributes
  }
}
    ${ComponentThemeLayoutAttributesFragmentDoc}`;
export const ComponentBrochureBlogListingAttributesFragmentDoc = gql`
    fragment ComponentBrochureBlogListingAttributes on ComponentBrochureBlogListing {
  title
  description
  background {
    color
  }
  collectionFilter {
    sortColumn
    sortOrder
    pageSize
    filter
  }
  layout {
    ...ComponentThemeLayoutAttributes
  }
}
    ${ComponentThemeLayoutAttributesFragmentDoc}`;
export const ComponentShopProductListingAttributesFragmentDoc = gql`
    fragment ComponentShopProductListingAttributes on ComponentShopProductListing {
  title
  description
  productCollectionFilter {
    sortOrder
    sortColumn
    productCount
    taxonId
  }
  productListingType
  products(pagination: {limit: -1}) {
    productId
  }
  layout {
    ...ComponentThemeLayoutAttributes
  }
  background {
    color
  }
  displayControl {
    ...DisplayControlAttributes
  }
}
    ${ComponentThemeLayoutAttributesFragmentDoc}
${DisplayControlAttributesFragmentDoc}`;
export const ComponentShopChannelNotificationAttributesFragmentDoc = gql`
    fragment ComponentShopChannelNotificationAttributes on ComponentShopChannelNotification {
  notificationText
  background {
    color
  }
}
    `;
export const ComponentCommonLivestreamAttributesFragmentDoc = gql`
    fragment ComponentCommonLivestreamAttributes on ComponentCommonLivestreamControl {
  floatingPlayer
  playlist
  channel
}
    `;
export const ComponentBrochureHtmlContainerAttributesFragmentDoc = gql`
    fragment ComponentBrochureHtmlContainerAttributes on ComponentBrochureHtmlContainer {
  content
}
    `;
export const ComponentShopNavigationItemAttributesFragmentDoc = gql`
    fragment ComponentShopNavigationItemAttributes on ComponentShopNavigationItem {
  text
  url
  openInNewTab
  position
  media {
    ...UploadFileResponse
  }
  taxonId
  icon
}
    ${UploadFileResponseFragmentDoc}`;
export const ComponentShopFooterLinksAttributesFragmentDoc = gql`
    fragment ComponentShopFooterLinksAttributes on ComponentShopFooterLinkComponent {
  labelOne
  linkCategoryOne {
    ...ComponentShopNavigationItemAttributes
  }
  labelTwo
  linkCategoryTwo {
    ...ComponentShopNavigationItemAttributes
  }
  labelThree
  linkCategoryThree {
    ...ComponentShopNavigationItemAttributes
  }
  labelFour
  linkCategoryFour {
    ...ComponentShopNavigationItemAttributes
  }
}
    ${ComponentShopNavigationItemAttributesFragmentDoc}`;
export const ComponentBrochureAnchorAttributesFragmentDoc = gql`
    fragment ComponentBrochureAnchorAttributes on ComponentBrochureAnchor {
  anchorId
}
    `;
export const ComponentBrochureExpansionPanelAttributesFragmentDoc = gql`
    fragment ComponentBrochureExpansionPanelAttributes on ComponentBrochureExpansionPanel {
  title
  text
}
    `;
export const ComponentBrochureAccordionAttributesFragmentDoc = gql`
    fragment ComponentBrochureAccordionAttributes on ComponentBrochureAccordion {
  title
  description
  expansionPanel(pagination: {limit: -1}) {
    ...ComponentBrochureExpansionPanelAttributes
  }
}
    ${ComponentBrochureExpansionPanelAttributesFragmentDoc}`;
export const ComponentShopCatalogReelAttributesFragmentDoc = gql`
    fragment ComponentShopCatalogReelAttributes on ComponentShopCatalogReel {
  media {
    ...UploadFileResponse
  }
  videoConfig {
    ...VideoConfigAttributes
  }
  productCollectionFilter {
    sortOrder
    sortColumn
    productCount
    taxonId
  }
  products(pagination: {limit: -1}) {
    productId
  }
  onlyShow4Products
  background {
    color
  }
  displayControl {
    ...DisplayControlAttributes
  }
}
    ${UploadFileResponseFragmentDoc}
${VideoConfigAttributesFragmentDoc}
${DisplayControlAttributesFragmentDoc}`;